var _defs, _rect, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatarDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#27272a;}.cls-2{fill:#a1a1aa;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 72,
    height: 72
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12 37.54 20.44 37.55 24.68 32.91 28.91 37.56 37.31 37.57 28.95 28.7 37.33 19.85 28.93 19.84 24.69 24.48 20.46 19.83 12.02 19.82 20.45 28.69 12 37.54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.58,19.48c-6.86,0-11.66,3.81-11.67,9.29S41.69,38,48.56,38,60,34.18,60,28.76s-4.69-9.27-11.42-9.28m4.83,9.28c0,2.38-2,4-5,4s-4.84-1.67-4.83-4.05,2-4.1,4.84-4.1,5,1.7,5,4.12",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.87,46.87A20,20,0,0,1,22.7,41.92v6.84a25.12,25.12,0,0,0,13.17,3.76A25.68,25.68,0,0,0,49.3,48.69V41.88a20.68,20.68,0,0,1-13.43,5",
    transform: "translate(0 0)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-default.ec510b6f0e87dacc2c92c9b0d3dbdca7.svg";